import { Capacitor } from "@capacitor/core";

// The web's auto-update: every deploy gives the bundle a new content hash, so
// comparing the main script hash this tab loaded against the one the server
// serves now says whether a newer build shipped. The watcher checks every few
// minutes and whenever the tab comes back into view, then tells the caller
// once (who shows the Refresh toast). Native apps update through the stores,
// never here.
const MAIN_RE = /\/static\/js\/main\.([a-f0-9]+)\.js/;

function mainScriptHash(html) {
  if (html != null) {
    const m = String(html).match(MAIN_RE);
    return m ? m[1] : null;
  }
  for (const s of document.scripts) {
    const m = (s.src || "").match(MAIN_RE);
    if (m) return m[1];
  }
  return null;
}

let started = false;

export function startWebUpdateWatch(onUpdate) {
  if (started) return undefined;
  try { if (Capacitor.isNativePlatform()) return undefined; } catch {}
  started = true;

  // A deploy can remove the previous build's lazy chunks under a stale tab:
  // reload once instead of dying on a chunk error (guarded against loops).
  window.addEventListener("error", (e) => {
    const msg = String((e && e.message) || "");
    if (/Loading chunk [\w-]+ failed|ChunkLoadError/i.test(msg)) {
      try {
        if (!sessionStorage.getItem("msChunkReload")) {
          sessionStorage.setItem("msChunkReload", "1");
          window.location.reload();
        }
      } catch { /* storage blocked: let the error surface */ }
    }
  });
  try { sessionStorage.removeItem("msChunkReload"); } catch {}

  const current = mainScriptHash();
  if (!current) return undefined; // dev server or unexpected markup

  let notified = false;
  const check = async () => {
    if (notified || document.visibilityState === "hidden") return;
    try {
      const r = await fetch(`/index.html?u=${Date.now()}`, { cache: "no-store" });
      if (!r.ok) return;
      const latest = mainScriptHash(await r.text());
      if (latest && latest !== current) {
        notified = true;
        onUpdate();
      }
    } catch { /* offline or blocked: try again next tick */ }
  };

  const iv = setInterval(check, 5 * 60 * 1000);
  const onVis = () => { if (document.visibilityState === "visible") check(); };
  document.addEventListener("visibilitychange", onVis);
  return () => { clearInterval(iv); document.removeEventListener("visibilitychange", onVis); };
}
